import * as React from 'react';
import { DragSourceMonitor, DropTargetMonitor, useDrag, useDrop } from 'react-dnd';
import { useDispatch } from 'react-redux';

import { useHasRole } from '../CurrentPerson';
import { addTaskToPathAtIndex, IDispatch, moveTaskOnPath } from '../state';
import { ISourceTaskItem } from './SourceTask';

type IProps = React.PropsWithChildren<{
    index: number;
    vertical?: boolean;
}>

export interface ITargetTaskItem {
    type: 'TARGET_TASK';
    index: number;
}

const TargetTask = ({ children, index, vertical }: IProps): JSX.Element => {
    const isAdmin = useHasRole(['admin']);
    const dispatch = useDispatch<IDispatch>();
    const ref = React.useRef<HTMLDivElement>(null);
    const [{ isOver }, dropRef] = useDrop({
        accept: ['SOURCE_TASK', 'TARGET_TASK'],
        drop: (item: ISourceTaskItem | ITargetTaskItem) => {
            if (item.type === 'SOURCE_TASK') {
                dispatch(addTaskToPathAtIndex(item.task, index));
            } else {
                dispatch(moveTaskOnPath(item.index, index));
            }
        },
        collect: (monitor: DropTargetMonitor) => ({
            isOver: monitor.isOver(),
        }),
    });
    const [{ isDragging }, dragRef] = useDrag({
        type: 'TARGET_TASK',
        item: () => ({ type: 'TARGET_TASK', index }),
        collect: (monitor: DragSourceMonitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });
    dragRef(dropRef(ref));
    const style: React.CSSProperties = {};
    style[vertical ? 'paddingTop' : 'paddingLeft'] = isOver ? 90 : 0;
    return <div ref={isAdmin ? ref : undefined} style={style}>
        {!isDragging && children}
    </div>;
};

export default TargetTask;
